import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { getInvoiceWarning, getStatusLabel } from '../constants';

const InvoiceStatusCell = ({ invoice, showWarning }) => {
  const warning = showWarning ? getInvoiceWarning(invoice) : null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Typography variant="small_2" sx={{ color: 'gray.A700', fontWeight: 500 }}>
        {getStatusLabel(invoice)}
      </Typography>
      {warning && (
        <Tooltip title={warning.text} placement="top">
          <WarningAmberIcon color="warning" sx={{ fontSize: 18, cursor: 'pointer' }} />
        </Tooltip>
      )}
    </Box>
  );
};

InvoiceStatusCell.propTypes = {
  invoice: PropTypes.shape({
    status: PropTypes.string,
    siiStatus: PropTypes.string,
    creditNoteStatus: PropTypes.string,
  }).isRequired,
  showWarning: PropTypes.bool,
};

InvoiceStatusCell.defaultProps = {
  showWarning: true,
};

export default InvoiceStatusCell;
